<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-xl-top-4">
          <div class="col-12">
            <div class="w-100 d-inline-block text-center mt-xl-0 mt-4">
              <p class="mb-0 text-size-14 text-uppercase text-gray fw-bold family-filson-bold text-full-14">
                our gallery
              </p>
              <h2 class="half-black fw-bold text-size-20 text-full-20 family-filson-bold margin-top-2 margin-bottom-2">
                Keeping tails wagging...
              </h2>
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-3">
          <div class="col-12">
            <div class="w-100 d-inline-block gallery-slider position-relative">
              <div class="carousel-container">
                <transition-group class="carousel" tag="div">
                  <div v-for="slide in slides" class="slide" :key="slide.id">
                    <img :src="slide.imgSrc" :alt="slide.title" class="slide-image rounded-3" />
                  </div>
                </transition-group>
                <div class="carousel-dots w-100 d-flex justify-content-center mt-4">
                  <span 
                    v-for="n in totalDots" 
                    :key="n"
                    class="slider-dot mx-1 rounded-circle cursor-pointer"
                    :class="{ 'active-dot': currentDot === n }"
                    @click="goToDot(n)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "gallerySliderComponent",
    data() {
      return {
        currentDot: 1,
        itemsPerDot: 2,
        slides: [
          {
            title: "pet care services, pet grooming tools",
            id: 1,
            imgSrc: require("@/assets/images/pet-care-services-pet-grooming-tools.png"),
          },
          {
            title: "pet grooming training, professional grooming team",
            id: 2,
            imgSrc: require("@/assets/images/pet-grooming-training-professional-grooming-team.png"),
          },
          {
            title: "pet groomer, pet grooming franchise",
            id: 3,
            imgSrc: require("@/assets/images/pet-groomer-pet-grooming-franchise.png"),
          },
          {
            title: "mobile pet grooming, pet grooming prices",
            id: 4,
            imgSrc: require("@/assets/images/mobile-pet-grooming-pet-grooming-prices.png"),
          },
          {
            title: "pet care services, pet grooming tools",
            id: 5,
            imgSrc: require("@/assets/images/pet-care-services-pet-grooming-tools.svg"),
          },
          {
            title: "pet grooming training, professional grooming team",
            id: 6,
            imgSrc: require("@/assets/images/pet-grooming-training-professional-grooming-team.svg"),
          },
          {
            title: "pet groomer, pet grooming franchise",
            id: 7,
            imgSrc: require("@/assets/images/pet-groomer-pet-grooming-franchise.svg"),
          },
          {
            title: "mobile pet grooming, pet grooming prices",
            id: 8,
            imgSrc: require("@/assets/images/mobile-pet-grooming-pet-grooming-prices.svg"),
          },
        ],
        isLoadingHomeGallery: false,
      };
    },
    computed: {
      totalDots() {
        return Math.ceil(this.slides.length / this.itemsPerDot);
      }
    },
    methods: {
      async fetchHomeGalleryImages() {
        if (this.isLoadingHomeGallery) return;
        try {
          this.isLoadingHomeGallery = true;
          const res = await this.$axios.post('/get-home-page', {
            website_name: this.activeWebsiteName,
          });
          const page = res?.data?.home_page;
          const imgs = page?.images;
          if (!Array.isArray(imgs) || imgs.length === 0) return;

          this.slides = imgs.map((path, i) => ({
            title: 'home gallery',
            id: i + 1,
            imgSrc: this.$getImageUrl(path),
          }));
          this.currentDot = 1;
        } catch (e) {
          console.error('fetchHomeGalleryImages', e);
        } finally {
          this.isLoadingHomeGallery = false;
        }
      },
      next() {
        const first = this.slides.shift();
        this.slides = this.slides.concat(first);
      },
      previous() {
        const last = this.slides.pop();
        this.slides = [last].concat(this.slides);
      },
      goToDot(n) {
        if (n === this.currentDot) return;
        
        let shiftCount = (n - this.currentDot) * this.itemsPerDot;
        if (shiftCount > 0) {
          for(let i = 0; i < shiftCount; i++) this.next();
        } else if (shiftCount < 0) {
          for(let i = 0; i < Math.abs(shiftCount); i++) this.previous();
        }
        this.currentDot = n;
      }
    },
    mounted() {
      this.fetchHomeGalleryImages();
    },
    watch: {
      activeWebsiteName() {
        this.fetchHomeGalleryImages();
      },
    },
  };
</script>

<style scoped>
  .carousel-dots {
    gap: 8px;
    margin-top: 30px;
  }
  .slider-dot {
    width: 8px;
    height: 8px;
    background-color: #D9D9D9; /* Light grey for inactive */
    display: inline-block;
    transition: all 0.3s ease;
  }
  .slider-dot.active-dot {
    background-color: #FD7E14; /* Orange for active */
    width: 8px;
    height: 8px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .slide-image {
    width: 100%;
    margin: 0 10px;
    border-radius: 12px;
    object-fit: cover;
  }
  .carousel {
    display: flex;
    overflow: hidden;
    padding: 10px 0;
  }
  .slide {
    flex: 0 0 25%; /* Show 4 items by default */
    padding: 0 10px;
    transition: all 0.5s ease;
  }
  @media (max-width: 991.98px) {
    .slide {
      flex: 0 0 50%;
    }
  }
  @media (max-width: 575.98px) {
    .slide {
      flex: 0 0 100%;
    }
  }
</style>
